import React from 'react';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { AccountData } from '../../components/account/accountData';
import { yourCompetitions } from './yourCompetitionRows';
import './YourCompetitions.css';

interface Props { data: AccountData; loading: boolean; onBrowse: () => void }

const YourCompetitions: React.FC<Props> = ({ data, loading, onBrowse }) => {
  const rows = yourCompetitions(data);
  return (
    <section className="your-competitions" aria-labelledby="your-competitions-heading" data-tour="your-competitions">
      <div className="your-competitions__head">
        <h2 id="your-competitions-heading">Your competitions</h2>
        {rows.length > 0 && <Link to="/profile/work" className="your-competitions__all">See all</Link>}
      </div>
      {loading ? (
        <LoadingSpinner size="sm" />
      ) : data.joined === null && data.judging === null && data.hosting === null ? (
        <p className="your-competitions__empty" role="alert">Couldn't load your competitions.</p>
      ) : rows.length === 0 ? (
        <p className="your-competitions__empty">
          No competitions yet.{' '}
          <button type="button" className="your-competitions__browse" onClick={onBrowse}>Browse competitions</button>
        </p>
      ) : (
        <ul className="your-competitions__list">
          {rows.map((row) => (
            <li key={row.key} className="your-competitions__row">
              {row.logo ? <img src={row.logo} alt="" className="your-competitions__logo" /> : <span className="your-competitions__logo" aria-hidden="true" />}
              <span className="your-competitions__text">
                <strong>{row.title}</strong>
                <span className="your-competitions__role">{row.role}</span>
                <span className="your-competitions__line">{row.line}</span>
              </span>
              <Link to={row.to} className="your-competitions__action" aria-label={`${row.action} ${row.title}`}>{row.action}</Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default YourCompetitions;
